
import Vue from 'vue';
import {mapActions, mapMutations, mapGetters} from 'vuex';
import LocationSearch from './location-search.vue';
import LocationTypeFilter from './location-type-filter.vue';
import ILocation from '../interfaces/ilocation';

declare const Alkami: any;

export default Vue.extend({
  name: 'locations-list',
  components: {LocationTypeFilter, LocationSearch},
  data() {
    return {
      Alkami,
      Locations: {} as ILocation[],
      AnyLocations: false,
      AnyPages: false,
      currentPage: 1,
      totalPages: 0,
      totalResults: 0
    };
  },
  computed: {
    ...mapGetters(
        [
            'getAllLocations',
            'SelectLocations',
            'getCurrentPageNumber',
            'getTotalSearchResults',
            'getAnyTotalPages',
            'getTotalPages',
            'getLocationMarkers'
        ]
    )
  },
  watch: {
    getAllLocations(value: ILocation[]) {
      this.Locations = value;
      this.AnyLocations = this.Locations.length > 0;
    },
    getCurrentPageNumber(value: number) {
      this.currentPage = value;
    },
    getAnyTotalPages(value: boolean) {
      this.AnyPages = value;
    },
    getTotalPages(value: number) {
      this.totalPages = value;
    },
    getTotalSearchResults(value: number) {
      this.totalResults = value;
    }
  },
  methods: {
    ...mapMutations(
      [
        'setCurrentPageNumber',
        'incrementPage',
        'decrementPage',
        'gotoFirstPage',
        'gotoLastPage',
        'setSelectedLocation',
        'setCurrentLocationMarker',
        'setIsLoading',
      ]
    ),
    ...mapActions(
      [
        'getFiByGeoLocationsAsync',
        'focusLocation',
        'unfocusLocation',
        'selectLocation'
      ]
    ),
    focusMarker(index: number) {
      this.focusLocation(index);
    },
    unfocusMarker() {
      this.unfocusLocation();
    },
    gotoPage() {
      this.setCurrentPageNumber(this.currentPage);
      this.movePage();
    },
    getNextPage() {
      this.incrementPage();
      this.movePage();
    },
    getPreviousPage() {
      this.decrementPage();
      this.movePage();
    },
    getFirstPage() {
      this.gotoFirstPage();
      this.movePage();
    },
    getLastPage() {
      this.gotoLastPage();
      this.movePage();
    },
    movePage() {
      this.getFiByGeoLocationsAsync();
      this.$refs.results_container.scrollTop = 0;
    },
    selectLoc(index: number) {
      this.setCurrentLocationMarker(this.getLocationMarkers[index]);
      this.setSelectedLocation(this.Locations[index]);
      this.selectLocation(index);
    }
  }
});
